import WorkspaceLayout from '../../components/navigation/WorkspaceLayout'

export default function AdminLayout() {
  return <WorkspaceLayout role="admin" />
}
